import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { api } from '@/lib/api';
import { eur, STATUS_LABELS, STATUS_COLORS, fmtDate } from '@/lib/format';

export default function RiderHistory() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get('/rider/orders/history').then(r => setOrders(r.data)); }, []);

  return (
    <div className="min-h-screen bg-[--brand-cream]">
      <header className="bg-white border-b border-[--brand-border] sticky top-0 z-30" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
        <div className="max-w-md mx-auto px-4 h-14 flex items-center gap-3">
          <Link to="/rider"><Button variant="ghost" size="icon" className="rounded-lg"><ArrowLeft size={16}/></Button></Link>
          <div className="font-display font-bold">Storico consegne</div>
        </div>
      </header>
      <main className="max-w-md mx-auto px-4 py-4 space-y-2">
        {orders.length === 0 ? (
          <div className="text-center text-sm text-[--brand-muted] py-8">Nessuna consegna passata</div>
        ) : orders.map(o => (
          <div key={o.id} className="rounded-xl bg-white border border-[--brand-border] p-3">
            <div className="flex justify-between items-center">
              <div className="font-semibold">#{o.order_number}</div>
              <Badge className={`${STATUS_COLORS[o.status]}`}>{STATUS_LABELS[o.status]}</Badge>
            </div>
            <div className="text-xs text-[--brand-muted]">{o.delivery_address}</div>
            <div className="flex justify-between mt-1 text-xs">
              <span className="text-[--brand-muted]">{fmtDate(o.delivered_at || o.updated_at)}</span>
              <span className="tabular-nums font-semibold">{eur(o.total)}</span>
            </div>
          </div>
        ))}
      </main>
    </div>
  );
}
